/*
 * @Description: 结算单模块
 * @Author: Harry
 * @Date: 2020-12-28 13:48:01
 * @LastEditTime: 2020-12-29 15:11:22
 * @LastEditors: Harry
 */
import i18n from "@/locales";
export default [
  {
    path: "/statement/list",
    name: "statement-list",
    component: () => import("@/views/statement/List.vue"),
    meta: {
      showHeader: true,
      keepAlive: true,
      title: i18n.t("statement.list.nav_title")
    }
  },
  {
    path: "/statement/detail",
    name: "statement-detail",
    component: () => import("@/views/statement/Detail.vue"),
    meta: {
      showHeader: false,
      title: i18n.t("statement.list.nav_title")
    }
  },
  {
    path: "/statement/preview",
    name: "statement-preview",
    component: () => import("@/views/statement/Preview.vue"),
    meta: {
      showHeader: false,
      keepAlive: true,
      title: i18n.t("statement.list.nav_title")
    }
  }
];
